import config from '../config';

export const getWMUrl = (eventId) => `${config.WM_URL}/marathon/${eventId}`;
export const getAhotuUrl = (permalink) =>
  `${config.AHOTU_URL}/event/${permalink}`;
